"use client";
import Tippy from "@tippyjs/react";
import React, { useState } from "react";

import * as tooltipStyles from "../styles/tooltip.module.scss";

import Link from "./Link";

const Tooltip = ({
	title,
	description,
	url,
	children,
	className,
	small,
	hover,
}) => {
	const [visible, setVisible] = useState(false);

	const hide = () => setVisible(false);

	const handleShow = (event) => {
		event.preventDefault();

		setVisible(true);
	};
	const extraClass = small ? " " + tooltipStyles.small : "";
	const handleHide = (event) => {
		event.preventDefault();

		hide();
	};

	return (
		<span
			className={
				tooltipStyles.container +
				" " +
				className +
				(small ? " " + tooltipStyles.smallContainer : "")
			}
		>
			<Tippy
				content={
					<>
						<a
							href="#"
							rel="noopener noreferrer"
							onClick={handleHide}
							className={tooltipStyles.close}
						>
							close
						</a>
						{description}
						{url && (
							<Link to={url} className={tooltipStyles.readMore}>
								Read more
							</Link>
						)}
					</>
				}
				interactive={true}
				className={tooltipStyles.tooltipContainer + extraClass}
				placement={"bottom"}
				visible={visible}
				onClickOutside={hide}
			>
				<a
					title={title}
					className={tooltipStyles.text}
					onClick={visible ? handleHide : handleShow}
					onMouseEnter={hover ? handleShow : () => {}}
					onMouseLeave={hover ? handleHide : () => {}}
				>
					{children ?? title}
				</a>
			</Tippy>
		</span>
	);
};

export default Tooltip;
